module.exports = __webpack_public_path__ + "img/0Q3B8790-7_H_FoamcoreMatted_MockedUp.45cf521e.jpg";